// Modern Email validation: Supports institutional subdomains (e.g. student@vel.tech.edu.in), dots, numbers, plus addressing
export const validateEmail = (email) => {
  if (!email) return false;
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+([.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email.trim());
};

// Helper to sanitize phone input (strips +91, leading 0, spaces, and non-digits)
export const cleanPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return "";
  let cleaned = phoneNumber.toString().trim();
  if (cleaned.startsWith("+91")) {
    cleaned = cleaned.slice(3);
  } else if (cleaned.startsWith("91") && cleaned.length > 10) {
    cleaned = cleaned.slice(2);
  } else if (cleaned.startsWith("0")) {
    cleaned = cleaned.slice(1);
  }
  return cleaned.replace(/\D/g, "").slice(0, 10);
};

// Indian standard: 10 digits, starting with 6/7/8/9
export const validatePhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return false;
  const cleaned = cleanPhoneNumber(phoneNumber);
  const phoneRegex = /^[6-9]\d{9}$/;
  return phoneRegex.test(cleaned);
};

// Name validation: Supports letters, spaces, initials with dots (e.g., A. Wilfred, M.S. Dhoni), hyphens, and apostrophes
export const validateName = (name) => {
  if (!name) return false;
  const trimmed = name.trim();
  if (trimmed.length < 1) return false;
  const regex = /^[A-Za-z\s.'-]+$/;
  return regex.test(trimmed) && /[A-Za-z]/.test(trimmed);
};


// Modern College Name: Supports full names with R&D, ampersands, commas, campus branches, and slashes (e.g. Vel Tech R&D Institute, Vel Tech, Avadi)
export const validateCollegeName = (value) => {
  if (!value) return false;
  const regex = /^[A-Za-z0-9\s&.\-(),/']{2,150}$/;
  return regex.test(value.trim());
};

// Modern Branch Name: Supports specialized branches, parentheses, slashes, ampersands, numbers (e.g. CSE (AI & ML), CSE - AI & ML, AI & DS, B.Tech IT, ECE / EEE)
export const validateBranchName = (branchName) => {
  if (!branchName) return false;
  const regex = /^[A-Za-z0-9\s&.\-(),/]{2,80}$/;
  return regex.test(branchName.trim());
};

